module.exports = __webpack_public_path__ + "static/img/cf20546171f97f5e6afdc87a18b8dbbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Mode0.png
// module id = ZJ5D
// module chunks = 1